import PropTypes from 'prop-types';

import {END_DATE, START_DATE,} from '../constants';

export default PropTypes.oneOf([START_DATE, END_DATE]);
